<template>
  <div class="admin-wrap">
    <div class="header">
      <h3 class="text-left" style="margin-right: auto">New Attendance Report (Daily)</h3>
      <div class="form">
        <div>Date: <input type="date" v-model="date" /></div>
      </div>
      <a :href="exportCsvUrl" download>Download CSV</a>
      <a :href="exportPdfUrl" download>Download PDF</a>
    </div>

    <table style="width: 100%">
      <tr>
        <th>Date</th>
        <th>Student Index No.</th>
        <th>Class Name</th>
        <th>Student Name</th>
        <th>Attendance Status</th>
        <th>Check In</th>
        <th>Check Out</th>
        <th>Temperatures</th>
        <th>Remarks</th>
      </tr>

      <tr v-for="(row, i) in table" :key="i">
        <td>{{ formatDate(row.AttendanceDate) }}</td>
        <td>{{ row.StudentIndexNo }}</td>
        <td>{{ row.ClassName }}</td>
        <td>{{ row.StudentName }}</td>
        <td>{{ row.AttendanceStatus ?? '-' }}</td>
        <td>{{ formatTime(row.CheckedInAt) }}</td>
        <td>{{ formatTime(row.CheckedOutAt) }}</td>
        <td>{{ row.TemperatureDetails ?? '-' }}</td>
        <td>{{ row.Remarks ?? '-' }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import DataSource from '@/data/datasource'
import { URLForEndpoint } from '@/data/requests'
import moment from 'moment'

export default {
  name: 'NewAttendanceReportDaily',
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      table: [],
    }
  },
  watch: {
    date() {
      this.update()
    },
  },
  computed: {
    params() {
      const school = Cookies.get('schoolSession')
      const userId = Cookies.get('userIDSession')
      const userType = Cookies.get('userTypeSession')
      return { school, from: this.date, to: this.date, UserID_Session: userId, UserType_Session: userType }
    },
    exportCsvUrl() {
      return URLForEndpoint('/controller/Api.asmx/AttendanceReport', {
        ...this.params,
        token: Cookies.get('authToken'),
        download: 'csv',
      })
    },
    exportPdfUrl() {
      return URLForEndpoint('/controller/Api.asmx/AttendanceReport', {
        ...this.params,
        token: Cookies.get('authToken'),
        download: 'pdf',
      })
    },
  },
  methods: {
    api(data = {}) {
      const payload = { ...this.params, ...data }
      return DataSource.shared.callWebService('/controller/Api.asmx/AttendanceReport', payload, 'POST')
    },
    async update() {
      this.table = []
      this.table = await this.api()
    },
    formatDate(input) {
      return input ? moment(input).format('YYYY-MM-DD') : '-'
    },
    formatTime(input) {
      return input ? moment(input).format('h:mm A') : '-'
    },
  },
  mounted() {
    this.update()
  },
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
}

.form {
  display: flex;
  gap: 10px;
}

select,
input {
  height: 30px;
  padding-left: 6px;
  padding-right: 6px;
}

table {
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #888;
  text-align: left;
  padding: 4px 6px;
  line-height: 1.2;
  white-space: pre-line;
}
</style>
